export default __webpack_public_path__ + "static/media/student_bg-380x335.7f774bba.jpg";